import { useState, useEffect } from 'react';

/**
 * Hook to manage global search (Spotlight) functionality
 * Provides keyboard shortcut (Ctrl+K / Cmd+K) to open search
 */
export const useGlobalSearch = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Check for Ctrl+K (Windows/Linux) or Cmd+K (Mac)
      if ((event.ctrlKey || event.metaKey) && event.key === 'k') {
        event.preventDefault();
        setOpen((prev) => !prev);
      }
      // Also close on Escape
      if (event.key === 'Escape' && open) {
        setOpen(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [open]);

  return {
    open,
    setOpen,
  };
};

